import React from "react"
import {useLocation} from "react-router-dom"
import {AsyncResultRequestState} from "../../types/asyncResult"
import {OkDocument, ErrorDocument} from "../../resources/common"
import {ManagedSolutionsAccount} from "../../resources/managedSolutions"
import {IcomoonIconName} from "../Icon/icons"
import {NavLink} from "../NavLink/NavLink"
import Icon from "../Icon/Icon"

interface AccountsSidebarItemProps {
	label: string
	link: string
	icon: IcomoonIconName
	operationalAccounts: AsyncResultRequestState<OkDocument<ManagedSolutionsAccount[]>, ErrorDocument>
}

export function AccountsSidebarItem({label, link, icon, operationalAccounts}: AccountsSidebarItemProps) {
	const location = useLocation()

	// Extract accountId from path like /managed-solutions/accounts/10030
	const accountIdMatch = location.pathname.match(/\/managed-solutions\/accounts\/(\d+)/)

	const currentAccountId = accountIdMatch ? accountIdMatch[1] : null

	// Check if current account is operational — if so, suppress active highlight on Accounts link
	const isCurrentAccountOperational = operationalAccounts.match(
		() => false,
		(result) => {
			if (!currentAccountId) return false
			return result.data.some((account) => account.id === currentAccountId)
		},
		() => false
	)

	return (
		<li>
			<NavLink className="has-icon" activeClassName={isCurrentAccountOperational ? undefined : "is-active"} to={link}>
				<div className="border-effect"></div>
				<span className="icon">
					<Icon size={16} icon={icon} />
				</span>
				<span className="nav-link-label">{label}</span>
			</NavLink>
		</li>
	)
}
